import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ApiService from '../services/apiService';
import AuthService from '../services/authService';
import config from '../config';
import moment from 'moment';
import L from '../services/localizationService';
import StorageService from '../services/storageService';

import BillingsForecast from './billingsforecast';
import CostCodeSeriesDialog from './costCodeSeriesDialog';
import CurrencyInput from './currencyinput';

import { CircularProgress } from '@rmwc/circular-progress';
import { Icon } from '@rmwc/icon';

import { DataTable, DataTableContent, DataTableHead, DataTableRow, DataTableHeadCell, DataTableCell, DataTableBody } from '@rmwc/data-table';
import { Button } from '@rmwc/button';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    const webClient = config.sytelineWebClient;
    this.sytelineFormUrl = (formSpec) =>
      `${webClient.portalUrl}?favoriteContext=${encodeURIComponent(formSpec)}&LogicalId=${encodeURIComponent(webClient.logicalId)}`;

    this.recalculatePOTotals = this.recalculatePOTotals.bind(this);
    this.handleOnBillingsForecastRecalculated = this.handleOnBillingsForecastRecalculated.bind(this);
    this.gotoCTCTiming = this.gotoCTCTiming.bind(this);
    this.gotoOPNR = this.gotoOPNR.bind(this);
    this._initialLoadComplete = false;
    this.defaultState = {
      applyExchangeRate: AuthService.isFAMConfig() && props.project.CurrCode && props.project.CurrCode.toUpperCase() === 'USD',
      projectTransactionsLink: null,
      forecastDate: moment().format('L LT'),
      exchangeRate: L.exchangeRate,

      categories: [],

      originalpo: '',
      corecvd: '',
      totalpo: 0,
      cotocome: '',
      totalcontract: 0,
      estgpus: 0,
      estgppct: 0,

      revenueFromTitle: '',
      revenueFrom: '',
      meetingRevenueFrom: '',
      revenueFromChange: 0,

      meetingTitle: '',
      meetingTotalContract: '',
      meetingInterCompanyBills: 0,
      meetingEstGP: '',
      meetingEstGPPct: '',

      meetingTotalContractChange: 0,
      meetingInterCompanyBillsChange: 0,
      meetingEstGPChange: 0,
      meetingEstGPPctChange: 0,

      forecastLines: null,

      billingsTotals: {
        invoicedToDateGross: 0,
        paidToDate: 0,
        totalAmountUnpaid: 0,
      },

      poTotals: {
        amountBilled: 0,
        openBalance: 0,
        poAmount: 0
      },

      projectCostDetailReport: null,
      projectTaskTens: null,

      billingsForecastStartMonth: moment(),
    }

    this.state = {
      loadingData: false,
      project: props.project,
      costCodeSeriesDialogOpen: false,
      selectedSeriesCodeIdx: null,
      ...Object.assign({}, this.defaultState)
    }

    this.dashboardSaveState = {
      meetingTitle: null,
      coToCome: null,
      billingsForecast: null
    }

    console.info('Project Currency is ', this.state.project.CurrCode);

  } 

  componentDidMount() {
    if (this.state.project) {
      this.updateDashboard(true);
      StorageService.startPolling(this.state.project.ProjNum.trim());
    }

    this._handleBeforeUnload = (e) => {
      if (document.activeElement) document.activeElement.blur();
      if (StorageService.pendingUpdates()) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', this._handleBeforeUnload);

    this._pollChangeTimer = setInterval(() => {
      let change = StorageService.getExternalChange();
      if (change) {
        StorageService.clearExternalChange();
        if (window.confirm(`This project was updated by ${change.updatedBy}. Reload to see their changes?`)) {
          this.updateDashboard(true);
        }
      }
    }, 5000);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this._handleBeforeUnload);
    if (this._pollChangeTimer) clearInterval(this._pollChangeTimer);
    StorageService.stopPolling();
    if (StorageService.hasUnsavedChanges()) {
      this.saveDashboardData();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.project !== prevProps.project) {
      let defaultProps = Object.assign({}, this.defaultState);

      console.info('Project Currency is ', this.props.project.CurrCode);

      this._initialLoadComplete = false;
      StorageService.startPolling(this.props.project.ProjNum.trim());
      this.setState({
        applyExchangeRate: AuthService.isFAMConfig() && this.props.project.CurrCode && this.props.project.CurrCode.toUpperCase() === 'USD',
        project: this.props.project,
        ...defaultProps
      }, () => {
        this.updateDashboard(true);
      });
    }
  }

  saveDashboardData() {
    this.dashboardSaveState.meetingTitle = this.state.meetingTitle;
    this.dashboardSaveState.coToCome = this.state.cotocome;
    this.dashboardSaveState.billingsForecastData = this.state.billingsForecast;

    this.dashboardSaveState.meetingTotalContract = this.state.meetingTotalContract;
    this.dashboardSaveState.meetingEstGP = this.state.meetingEstGP;
    this.dashboardSaveState.meetingEstGPPct = this.state.meetingEstGPPct;

    this.dashboardSaveState.billingsForecastData = this.state.billingsForecast;

    this.dashboardSaveState.revenueFromTitle = this.state.revenueFromTitle;
    this.dashboardSaveState.revenueFrom = this.state.revenueFrom;
    this.dashboardSaveState.meetingRevenueFrom = this.state.meetingRevenueFrom;

    StorageService.saveDashboardData(this.dashboardSaveState);
  }

  handleOnBillingsForecastRecalculated(calculations) {
    this.setState({ billingsForecast: calculations }, () => {
      this.updateExportDataset()
      if (this._initialLoadComplete) {
        this.dashboardSaveState.billingsForecastData = calculations;
        this.saveDashboardData();
      }
    });
    
  }

  updateExportDataset() {
    if (this.props.onExportDataset) {
      this.props.onExportDataset(this.state);
    }
  }
  
  updateDashboard(doRestore) {
    let statesToUpdate = {};

    L.setExchangeRate(1.00);

    this.setState({
      loadingData: true,
      exchangeRate: 1.00}
    );

    let startingPromise = null;
    if (this.state.applyExchangeRate) {
      startingPromise = ApiService.getMexicanExchangeRates()
      .then((rates) => {
        if (rates.length > 0) {
          let rate = rates[0].SellRate;
          console.log('Using MXN SellRate: ', rate);
          L.setExchangeRate(rate)
          this.setState({
            exchangeRate: rate
          });
        }

        return ApiService.getProjectCostDetailReport(this.props.project.ProjNum);
      })
    }
    else {
      startingPromise = ApiService.getProjectCostDetailReport(this.props.project.ProjNum);
    }

    startingPromise
      .then((projectCostDetailReport) => {
        // Build totals
        let projectCostDetailTotals = {
          ETAmount: 0,
          actualCost: 0,
          opnr: 0,
          committedCost: 0,
          estimatedFinalCost: 0,
          amountToSpend: 0,
          ETVariance: 0,
          DerTotalRcvdCostExchVol: 0,
          DerTotalOrderedExchVol: 0,
          PlanCost: 0,
      }

        let categories = L.costCodeDescriptions.map(d => { return {
            name: d, totals: Object.assign({}, projectCostDetailTotals), items: []
          }});

        //   { name: 'Mechanical Components', totals: Object.assign({}, projectCostDetailTotals), items: [] },
         
        //   { name: 'Electrical Components', totals: Object.assign({}, projectCostDetailTotals), items: [] },
         
        //   { name: 'Major Purchases', totals: Object.assign({}, projectCostDetailTotals), items: [] },
         
        //   { name: 'Production Labor', totals: Object.assign({}, projectCostDetailTotals), items: [] },
         
        //   { name: 'Engineering', totals: Object.assign({}, projectCostDetailTotals), items: [] },
         
        //   { name: 'Installation Materials', totals: Object.assign({}, projectCostDetailTotals), items: [] }, 
         
        //   { name: 'Mechanical Installation', totals: Object.assign({}, projectCostDetailTotals), items: [] },
         
        //   { name: 'Electrical Installation', totals: Object.assign({}, projectCostDetailTotals), items: [] }, 
         
        //   { name: 'Site Supervision', totals: Object.assign({}, projectCostDetailTotals), items: [] },
        // ];

        projectCostDetailReport.forEach((item) => {
          let idx = L.costCodeToIndex(item.CostCode);
          if (idx != null) {
            if (categories[idx].items.find(i => i.CostCode === item.CostCode)) {
              categories[idx].hasDuplicates = true;
            }
            categories[idx].items.push(item);

            categories[idx].totals.ETAmount += L.parseFloatWithZero(item.PlanCost);
            categories[idx].totals.actualCost += L.parseFloatWithZero(item.ACost);
            // categories[idx].totals.opnr += L.parseFloatWithZero(item.DerOPNR); - No exchange
            categories[idx].totals.opnr += L.parseFloatWithZero(item.DerOPNR);
            //categories[idx].totals.opnr += L.parseFloatWithZero(item.DerOPNRExch);
            categories[idx].totals.committedCost += L.parseFloatWithZero(item.DerFataCommittedCostExch);
            categories[idx].totals.estimatedFinalCost += L.parseFloatWithZero(item.EstimatedFinalCost);
            categories[idx].totals.amountToSpend += L.parseFloatWithZero(item.AmountToSpend);
            categories[idx].totals.ETVariance += L.parseFloatWithZero(item.DerETVariance);
            categories[idx].totals.DerTotalRcvdCostExchVol =+ L.parseFloatWithZero(item.DerTotalRcvdCostExchVol);
            categories[idx].totals.DerTotalOrderedExchVol =+ L.parseFloatWithZero(item.DerTotalOrderedExchVol);
            categories[idx].totals.PlanCost += L.parseFloatWithZero(item.PlanCost);
            
            projectCostDetailTotals.ETAmount += L.parseFloatWithZero(item.PlanCost);
            projectCostDetailTotals.actualCost += L.parseFloatWithZero(item.ACost);
            projectCostDetailTotals.opnr += L.parseFloatWithZero(item.DerOPNR);
            //projectCostDetailTotals.opnr += L.parseFloatWithZero(item.DerOPNRExch);
            projectCostDetailTotals.committedCost += L.parseFloatWithZero(item.DerFataCommittedCostExch);
            projectCostDetailTotals.estimatedFinalCost += L.parseFloatWithZero(item.EstimatedFinalCost);
            projectCostDetailTotals.amountToSpend += L.parseFloatWithZero(item.AmountToSpend);
            projectCostDetailTotals.ETVariance += L.parseFloatWithZero(item.DerETVariance);
          }
          else {
            console.error(`No CostCode ${item.CostCode} index ${idx}`);
          }
        })

        console.log('categories', categories)
        statesToUpdate.projectCostDetailTotals = projectCostDetailTotals;
        statesToUpdate.projectCostDetailReport = projectCostDetailReport;
        statesToUpdate.categories = categories;
        // this.setState({ projectCostDetailTotals: projectCostDetailTotals });
        // this.setState({ projectCostDetailReport: projectCostDetailReport });
        // this.setState({ categories: categories });

        return ApiService.getProjectCodes(this.props.project.ProjNum);
      })
      .then((costCodes) => { 
        statesToUpdate.costCodes = costCodes;
//        this.setState({costCodes : costCodes});

        return ApiService.getProjectBillingsReport(this.props.project.ProjNum);
      })
      .then((projectBillingsReport) => {

        let billingsTotals = {
          invoicedToDateGross: 0,
          paidToDate: 0,
          totalAmountUnpaid: 0
        }

        projectBillingsReport.forEach((item) => {
          billingsTotals.invoicedToDateGross += L.parseFloatWithZeroConv(item.Amount);
          billingsTotals.paidToDate += L.parseFloatWithZeroConv(item.AmountPaid);
          billingsTotals.totalAmountUnpaid += L.parseFloatWithZeroConv(item.Outstanding);
        });

        statesToUpdate.billingsTotals = billingsTotals;
        // this.setState({ billingsTotals: billingsTotals });

        return ApiService.getProjectPOReport(this.props.project.ProjNum);
      })
      .then((projectPOReport) => {
        let poTotals = {
          amountBilled: 0,
          openBalance: 0,
          poAmount: 0
        }

        let firstItem = true;
        let originalPOAmount = 0;
        let changeOrderAmountReceived = 0;
        projectPOReport.forEach((item) => {
          if (firstItem) {
            originalPOAmount = L.parseFloatWithZeroConv(item.POAmount);
            firstItem = false;
          }
          else {
            changeOrderAmountReceived += L.parseFloatWithZeroConv(item.POAmount);
          }

          poTotals.amountBilled += L.parseFloatWithZeroConv(item.AmountBilled);
          poTotals.openBalance += L.parseFloatWithZeroConv(item.OpenBalance);
          poTotals.poAmount += L.parseFloatWithZeroConv(item.POAmount);
        });

        statesToUpdate.originalpo = originalPOAmount;
        statesToUpdate.corecvd = changeOrderAmountReceived;
        statesToUpdate.poTotals = poTotals;
        statesToUpdate.loadingData = false;

        if (doRestore) {
          StorageService.restoreData(this.props.project.ProjNum).then((existingDashboardData) => {
            let finalStatesToUpdate = { ...statesToUpdate };
            if (existingDashboardData && existingDashboardData.dashboard) {
              finalStatesToUpdate = {
                ...statesToUpdate,
                meetingTitle: existingDashboardData.dashboard.meetingTitle,
                cotocome: existingDashboardData.dashboard.coToCome,
                meetingTotalContract: existingDashboardData.dashboard.meetingTotalContract,
                meetingEstGP: existingDashboardData.dashboard.meetingEstGP,
                meetingEstGPPct: existingDashboardData.dashboard.meetingEstGPPct,
                revenueFromTitle: existingDashboardData.dashboard.revenueFromTitle,
                revenueFrom: existingDashboardData.dashboard.revenueFrom,
                meetingRevenueFrom: existingDashboardData.dashboard.meetingRevenueFrom
              };

              if (existingDashboardData.dashboard.billingsForecastData) {
                finalStatesToUpdate.forecastLines = existingDashboardData.dashboard.billingsForecastData.forecastLines;
                finalStatesToUpdate.billingsForecast = existingDashboardData.dashboard.billingsForecastData;
              }
            }
            this.setState(finalStatesToUpdate, () => { this.recalculatePOTotals(); this._initialLoadComplete = true; });
          })
        }
        else {
          this.setState(statesToUpdate, () => { this.recalculatePOTotals(); this._initialLoadComplete = true; });
        }
      })
  }

  showCostCodeSeriesDialog(seriesIndex) {
    document.body.classList.add('sitewide-progress'); 

    ApiService.getProjectTaskTens(this.props.project.ProjNum)
      .then((projectTaskTens) => {
        let tasks = [];
        let projectCostCodeTotals = [];
        projectTaskTens.forEach((item) => {
          let itemSeriesCodeIdx = L.costCodeToIndex(item.CostCode);

          if (itemSeriesCodeIdx === seriesIndex) {

            if (item.Type === 'T' && item.TaskNum === '10') {
              tasks.push(item);
            }

            if (item.TaskNum === '0') {
              let costCodeTotal = projectCostCodeTotals.find(e => e.CostCode === item.CostCode);

              if (!costCodeTotal) {
                costCodeTotal = {
                  CostCode: item.CostCode,
                  totalCommitted: 0,
                  totalRevisedEt: 0,
                  rowCount: 0,
                }
                projectCostCodeTotals.push(costCodeTotal);
              }
              costCodeTotal.totalCommitted += L.parseFloatWithZero(item.DerFataCommittedCost);
              costCodeTotal.totalRevisedEt += L.parseFloatWithZero(item.PlanCost);
              costCodeTotal.rowCount++;
            }
          }
        })

        console.log('projectCostCodeTotals', projectCostCodeTotals);
        let totalForSeries = 0;
        projectCostCodeTotals.forEach((item) => {
          totalForSeries += item.total;
        })
        console.log('totalForSeries', totalForSeries);

        this.setState({
          projectTaskTens : tasks,
          projectCostCodeTotals: projectCostCodeTotals,
          selectedSeriesCodeIdx: seriesIndex}, 
          () => {
            this.setState( { costCodeSeriesDialogOpen : true });
          });
      })
      .finally(() => {
        document.body.classList.remove('sitewide-progress'); 
      })
  }

  projectCostDetailReportSection() {
    if (this.state.categories.length > 0 && !this.state.loadingData) {
      let tableContent = null;

      tableContent = this.state.categories.map((item, index) => {
        return <DataTableRow className="clickable-data-row" key={index} onClick={() => { this.showCostCodeSeriesDialog(index)}}>
          <DataTableCell>{index}00 SERIES{item.hasDuplicates ? <Icon icon="warning" style={{color: 'orange', fontSize: '16px', marginLeft: '4px', verticalAlign: 'middle'}} /> : null}</DataTableCell>
          <DataTableCell>{item.name}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.totals.ETAmount)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.totals.actualCost)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.totals.opnr)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.totals.committedCost)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.totals.amountToSpend)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.totals.estimatedFinalCost)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.totals.ETVariance)}</DataTableCell>
        </DataTableRow>;
      });

      return <DataTable className="dashboard-detail-report-table">
        <DataTableContent>
          <DataTableHead>
            <DataTableRow>
              <DataTableHeadCell alignMiddle>Cost Code</DataTableHeadCell>
              <DataTableHeadCell className="description-width" alignMiddle>Description</DataTableHeadCell>
              {/* <DataTableHeadCell alignMiddle>ET Amount</DataTableHeadCell> */}
              <DataTableHeadCell alignMiddle>Revised<br/>ET</DataTableHeadCell>
              {/* <DataTableHeadCell alignMiddle>Actual Cost</DataTableHeadCell> */}
              <DataTableHeadCell alignMiddle>W.I.P.</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>OPNR</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>Total<br/>Committed</DataTableHeadCell>
              {/* <DataTableHeadCell alignMiddle>Committed<br/>Cost</DataTableHeadCell> */}
              <DataTableHeadCell alignMiddle>Amount<br/>To Spend</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>Estimated<br/>Final Cost</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>ET<br/>Variance</DataTableHeadCell>
            </DataTableRow>
          </DataTableHead>

          <DataTableBody>

            {tableContent}

            <DataTableRow>
              <DataTableCell className="totals-row"></DataTableCell>
              <DataTableCell className="totals-row">TOTALS</DataTableCell>
              <DataTableCell className="totals-row">{L.toCurrencyString(this.state.projectCostDetailTotals.ETAmount)}</DataTableCell>
              <DataTableCell className="totals-row">{L.toCurrencyString(this.state.projectCostDetailTotals.actualCost)}</DataTableCell>
              <DataTableCell className="totals-row">{L.toCurrencyString(this.state.projectCostDetailTotals.opnr)}</DataTableCell>
              <DataTableCell className="totals-row">{L.toCurrencyString(this.state.projectCostDetailTotals.committedCost)}</DataTableCell>
              <DataTableCell className="totals-row">{L.toCurrencyString(this.state.projectCostDetailTotals.amountToSpend)}</DataTableCell>
              <DataTableCell className="totals-row">{L.toCurrencyString(this.state.projectCostDetailTotals.estimatedFinalCost)}</DataTableCell>
              <DataTableCell className="totals-row">{L.toCurrencyString(this.state.projectCostDetailTotals.ETVariance)}</DataTableCell>
            </DataTableRow>

          </DataTableBody>
        </DataTableContent>
      </DataTable>
    }
    return <div style={{textAlign: 'center'}}>Loading Project Details...<br/><CircularProgress /></div>
  }


  projectCostDetailReportSectionItems() {
    if (this.state.projectCostDetailReport) {
      let tableContent = null;

      tableContent = this.state.projectCostDetailReport.map((item, index) => {
        return <DataTableRow key={index}>
          <DataTableCell>{item.CostCode}</DataTableCell>
          <DataTableCell>{item.WMS_DerCostCodeDescription}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.PlanCost)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.ACost)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.DerOPNR)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.DerFataCommittedCost)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.EstimatedFinalCost)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.AmountToSpend)}</DataTableCell>
          <DataTableCell>{L.toCurrencyString(item.DerETVariance)}</DataTableCell>
        </DataTableRow>;
      });

      return <DataTable className="dashboard-detail-report-table">
        <DataTableContent>
          <DataTableHead>
            <DataTableRow>
              <DataTableHeadCell alignMiddle>Cost Code</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>Description</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>ET Amount</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>Actual Cost</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>OPNR</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>Committed<br/>Cost</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>Estimated<br/>Final Cost</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>Amount<br/>To Spend</DataTableHeadCell>
              <DataTableHeadCell alignMiddle>ET<br/>Variance</DataTableHeadCell>
            </DataTableRow>
          </DataTableHead>

          <DataTableBody>

            {tableContent}

            <DataTableRow>
              <DataTableCell></DataTableCell>
              <DataTableCell style={{ width: '30%' }}>TOTALS</DataTableCell>
              <DataTableCell>{L.toCurrencyString(this.state.projectCostDetailTotals.ETAmount)}</DataTableCell>
              <DataTableCell>{L.toCurrencyString(this.state.projectCostDetailTotals.actualCost)}</DataTableCell>
              <DataTableCell>{L.toCurrencyString(this.state.projectCostDetailTotals.opnr)}</DataTableCell>
              <DataTableCell>{L.toCurrencyString(this.state.projectCostDetailTotals.committedCost)}</DataTableCell>
              <DataTableCell>{L.toCurrencyString(this.state.projectCostDetailTotals.estimatedFinalCost)}</DataTableCell>
              <DataTableCell>{L.toCurrencyString(this.state.projectCostDetailTotals.amountToSpend)}</DataTableCell>
              <DataTableCell>{L.toCurrencyString(this.state.projectCostDetailTotals.ETVariance)}</DataTableCell>
            </DataTableRow>

          </DataTableBody>
        </DataTableContent>
      </DataTable>
    }
    return <CircularProgress />
  }
  
  recalculatePOTotals() {
    let originalpoAmt = 0;
    let corecvdAmt = 0;
    let cotocomAmt = 0;

    let totalpoAmt = 0;
    let estgpusAmt = 0;
    let estgppctAmt = 0;
    let totalcontractAmt = 0;

    let meetingTotalContractChangeAmt;
    let meetingInterCompanyBillsChangeAmt;
    let meetingEstGPChangeAmt;
    let meetingEstGPPctChangeAmt;
    let revenueFromChangeAmt = 0;
    
    console.debug('recalculatePOTotals', 'recalculating, est final cost is ', this.state.projectCostDetailTotals.estimatedFinalCost);

    try {
      originalpoAmt = L.parseFloatWithZero(this.state.originalpo);
      corecvdAmt = L.parseFloatWithZero(this.state.corecvd);
      cotocomAmt = L.parseFloatWithZero(this.state.cotocome);
      let revenueFrom = L.parseFloatWithZero(this.state.revenueFrom);

      totalpoAmt = originalpoAmt + corecvdAmt;
      totalcontractAmt = totalpoAmt + cotocomAmt;

      estgpusAmt = (totalcontractAmt + revenueFrom) - this.state.projectCostDetailTotals.estimatedFinalCost;
      estgppctAmt = Math.round((estgpusAmt / totalcontractAmt) * 100);
    }
    catch (err) {
      console.debug('recalculatePOTotals', err);
    }

    try {
      meetingTotalContractChangeAmt = totalcontractAmt - L.parseFloatWithZero(this.state.meetingTotalContract);
//      meetingInterCompanyBillsChangeAmt = totalcontractAmt - L.parseFloatWithZero(this.state.meetingInterCompanyBills);
      meetingEstGPChangeAmt = estgpusAmt - L.parseFloatWithZero(this.state.meetingEstGP);
      meetingEstGPPctChangeAmt = estgppctAmt - L.parseFloatWithZero(this.state.meetingEstGPPct);
      revenueFromChangeAmt = this.state.revenueFrom - this.state.meetingRevenueFrom;
    }
    catch (err) {
      console.debug('recalculatePOTotalsA', err);
    }

    this.setState({
      totalpo: totalpoAmt,
      estgpus: estgpusAmt,
      estgppct: estgppctAmt,
      totalcontract: totalcontractAmt,
      meetingTotalContractChange: meetingTotalContractChangeAmt,
      meetingInterCompanyBillsChange: meetingInterCompanyBillsChangeAmt,
      revenueFromChange: revenueFromChangeAmt,
      meetingEstGPChange: meetingEstGPChangeAmt,
      meetingEstGPPctChange :meetingEstGPPctChangeAmt
      }, () => this.updateExportDataset());
  }

  gotoCTCTiming() {
    this.setState( { toCTCTiming: true});
  }

  gotoOPNR() {
    this.setState( { toOPNR: true});
  }

  render() {

    let projectTransactionsUrl = null;
    let projectPOReportUrl = null;
    let projectCostDetailReportUrl = null;
    let projectBillingsReportUrl = null;
    let projectCommittedCostsReportUrl = null;

    if (this.state.project) {
      const projNum = this.state.project.ProjNum;

      projectTransactionsUrl = this.sytelineFormUrl(`ProjectTransactions(SETVARVALUES(InitialCommand=Refresh)FILTER(ProjNum='${projNum}'))`);

      projectPOReportUrl = this.sytelineFormUrl(`GDL_ProjectPOReport(SETVARVALUES(ProjectNum=${projNum},InitialCommand=Event PreviewReport))`);

      projectCostDetailReportUrl = this.sytelineFormUrl(`GDL_ProjectCostDetailReport(SETVARVALUES(ProjectNum=${projNum},InitialCommand=Event PreviewReport))`);

      projectBillingsReportUrl = this.sytelineFormUrl(`GDL_ProjectBillingsReport(SETVARVALUES(ProjectNum=${projNum},InitialCommand=Event PreviewReport))`);

      projectCommittedCostsReportUrl = this.sytelineFormUrl(`WBDataViewResults(SETVARVALUES(DataViewName=_FATA Project Committed Costs,InputParameter1=${projNum}))`);
    }

    // On-prem this opened the Projects form first to start a web client session, then the
    // report 6 seconds later. The Infor OS portal handles the session, so open the form directly.
    function launchReport(url) {
      window.open(url, 'fata_dashboard_syteline_report');
    }

    if (this.state.toCTCTiming) {
      return <Redirect to="/ctctiming" push />
    } 
    else if  (this.state.toOPNR) {
      return <Redirect to="/opnr" push />
    } 
    else {
      return (
        <div className="dashboard content-max-width">
          <CostCodeSeriesDialog projNum={this.state.project.ProjNum} open={this.state.costCodeSeriesDialogOpen}
            onClose={(isSaving) => { if (!isSaving) this.setState({ costCodeSeriesDialogOpen: false })}}
            onSaved={() => { this.setState({ costCodeSeriesDialogOpen: false }); this.updateDashboard()}}
            projectTaskTens={this.state.projectTaskTens}
            seriesCodeIdx={this.state.selectedSeriesCodeIdx}
            projectCostCodeTotals={this.state.projectCostCodeTotals}
            costCodes={this.state.costCodes}
            onLaunchCostDetailReport={() => { launchReport(projectCostDetailReportUrl); }}
          />
          <div className="dashboard-top">
            <div className="dashboard-top-header">
              <label>Project #:</label>{this.state.project.ProjNum.trim()}<br/>
              <label>Proj. Mgr.:</label>{this.state.project.ProjMgr}
            </div>
            <div className="forecast-date-section">
              <label>Forecast Date:</label>{this.state.forecastDate}<br/>
              { this.state.applyExchangeRate ? <div><label>MXN/USD Rate:</label>{this.state.exchangeRate}</div> : null }
            </div>
          </div>

          <div className="dashboard-detail-report-section">
            {this.projectCostDetailReportSection()}
          </div>

          <div className="dashboard-data-section">
            <div className="data-section-totals-section">
              <div className="label-input-item">
                <label htmlFor="originalpo">Original P.O.</label>
                <input id="originalpo" value={L.toCurrencyString(this.state.originalpo)} readOnly />
              </div>

              <div className="label-input-item">
                <label htmlFor="corecvd">C.O. $ Recvd</label>
                <input id="corecvd" value={L.toCurrencyString(this.state.corecvd)} readOnly />
              </div>

              <div className="label-input-item">
                <label htmlFor="totalpo">Total P.O.</label>
                <input id="totalpo" value={L.toCurrencyString(this.state.totalpo)} readOnly />
              </div>

              <div className="label-input-item">
                <label htmlFor="cotocome">C.O. $ To Come</label>
                <CurrencyInput id="cotocome" value={this.state.cotocome}
                  onChanged={(newValue) => { this.setState({ cotocome: newValue }, () => { this.recalculatePOTotals(); this.saveDashboardData();}) }} />

                {/* <input id="cotocome"
                value={this.state.cotocome}
                  onChange={(e) => this.setState({ cotocome: e.target.value })}
                  onBlur={() => { this.recalculatePOTotals(); this.saveDashboardData(); } } /> */}

                <input id="meetingTitleBox"
                className="centered"
                placeholder="Prev. Meeting"
                value={this.state.meetingTitle}
                  onChange={(e) => this.setState({ meetingTitle: e.target.value })}
                  onBlur={() => { this.recalculatePOTotals(); this.saveDashboardData(); } } />
                  <label className="change-title">Change</label>
              </div>

              <div className="label-input-item">
                <label htmlFor="totalcontract">Total Contract</label>
                <input id="totalcontract" value={L.toCurrencyString(this.state.totalcontract)} readOnly />

                <CurrencyInput id="meetingTotalContract" value={this.state.meetingTotalContract}
                  onChanged={(newValue) => { this.setState({ meetingTotalContract: newValue }, () => { this.recalculatePOTotals(); this.saveDashboardData();}) }} />
                {/* <input id="meetingTotalContract"
                value={this.state.meetingTotalContract}
                  onChange={(e) => this.setState({ meetingTotalContract: e.target.value })}
                  onBlur={() => { this.recalculatePOTotals(); this.saveDashboardData(); } } /> */}

                <input id="meetingTotalContractChange"
                  value={L.toCurrencyString(this.state.meetingTotalContractChange)} readOnly />
              </div>
              <br />

              {/* Revenue From */}
              <div className="label-input-item">
                <input id="revenueFromTitle"
                  placeholder="Revenue From"
                  className="revenue-from-input"
                  value={this.state.revenueFromTitle || ''}
                  onChange={(e) => this.setState({ revenueFromTitle: e.target.value })}
                  onBlur={() => { this.saveDashboardData(); } } />


                <CurrencyInput id="revenueFrom" value={this.state.revenueFrom}
                  onChanged={(newValue) => { this.setState({ revenueFrom: newValue }, () => { this.recalculatePOTotals(); this.saveDashboardData();}) }} />

                {/* <input id="revenueFrom"
                  value={this.state.revenueFrom}
                  onChange={(e) => this.setState({ revenueFrom: e.target.value })}
                  onBlur={() => { this.recalculatePOTotals(); this.saveDashboardData(); } } /> */}

                <CurrencyInput id="meetingRevenueFrom" value={this.state.meetingRevenueFrom}
                  onChanged={(newValue) => { this.setState({ meetingRevenueFrom: newValue }, () => { this.recalculatePOTotals(); this.saveDashboardData();}) }} />

                {/* <input id="meetingRevenueFrom"
                  value={this.state.meetingRevenueFrom}
                  onChange={(e) => this.setState({ meetingRevenueFrom: e.target.value })}
                  onBlur={() => { this.recalculatePOTotals(); this.saveDashboardData(); } } /> */}
                
                <input id="revenueFromChange"
                  value={L.toCurrencyString(this.state.revenueFromChange)} readOnly />
              </div>

              {/* EST. GP US */}
              <div className="label-input-item">
                <label htmlFor="estgpus">Est. GP US</label>
                <input id="estgpus" value={L.toCurrencyString(this.state.estgpus)} readOnly />

                <CurrencyInput id="meetingEstGP" value={this.state.meetingEstGP}
                  onChanged={(newValue) => { this.setState({ meetingEstGP: newValue }, () => { this.recalculatePOTotals(); this.saveDashboardData();}) }} />

                {/* <input id="meetingEstGP"
                  value={this.state.meetingEstGP}
                  onChange={(e) => this.setState({ meetingEstGP: e.target.value })}
                  onBlur={() => { this.recalculatePOTotals(); this.saveDashboardData(); } } /> */}

                <input id="meetingEstGPChange"
                  value={L.toCurrencyString(this.state.meetingEstGPChange)} readOnly />
              </div>

              {/* EST GP % */}
              <div className="label-input-item">
                <label htmlFor="estgppct">Est GP %</label>
                <input id="estgppct" value={L.toPercentString(this.state.estgppct)} readOnly />

                <input id="meetingEstGPPct"
                value={this.state.meetingEstGPPct}
                  onChange={(e) => this.setState({ meetingEstGPPct: e.target.value })}
                  onBlur={() => { this.recalculatePOTotals(); this.saveDashboardData(); } } />
                <input id="meetingEstGPPctChange"
                  value={L.toPercentString(this.state.meetingEstGPPctChange)} readOnly />
              </div>
            </div>

            <div className="dashboard-data-section-right">
              <div className="data-section-invoice-to-date-section">

                <div className="label-input-item">
                  <label htmlFor="invoicedToDateGross">Invoiced To Date - Net</label>
                  <input id="invoicedToDateGross" value={L.toCurrencyString(this.state.billingsTotals.invoicedToDateGross)} readOnly />
                </div>
                <div className="label-input-item">
                  <label htmlFor="paidToDate">Paid To Date</label>
                  <input id="paidToDate" value={L.toCurrencyString(this.state.billingsTotals.paidToDate)} readOnly />
                </div>
                <div className="label-input-item">
                  <label htmlFor="totalAmountUnpaid">Total Amount Unpaid</label>
                  <input id="totalAmountUnpaid" value={L.toCurrencyString(this.state.billingsTotals.totalAmountUnpaid)} readOnly />
                </div>
              </div>
              <div className="data-section-report-buttons-section no-print">
                <div className="buttons-row">
                  <Button className="report-button" raised onClick={() => { this.gotoOPNR() }}>OPNR</Button>
                  <Button className="report-button" raised onClick={() => { this.gotoCTCTiming() }}>CTC Timing</Button>
                  <Button className="report-button" raised onClick={() => {launchReport(projectTransactionsUrl)}}>Project<br/>Transactions</Button>
                  <Button className="report-button" raised onClick={() => {launchReport(projectCostDetailReportUrl)}}>Project Cost<br/>Detail Report</Button>
                </div>
                <div className="buttons-row">
                  <Button className="report-button" raised onClick={() => {launchReport(projectPOReportUrl)}}>Project<br/>PO Report</Button>
                  <Button className="report-button" raised onClick={() => {launchReport(projectBillingsReportUrl)}}>Project<br/>Billings</Button>
                  <Button className="report-button" raised onClick={() => {launchReport(projectCommittedCostsReportUrl)}}>Committed<br/>Costs</Button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3>Billings Forecast</h3>
            <BillingsForecast project={this.props.project} 
              onRecalculated={this.handleOnBillingsForecastRecalculated}
              totalContract={this.state.totalcontract}
              forecastLines={this.state.forecastLines}
              billingsForecast={this.state.billingsForecast}
              invoicedToDateGross={this.state.billingsTotals.invoicedToDateGross} />
          </div>
        </div>
      );
    }
  }
}

export default Dashboard;
